import React from 'react';

import PolicyPage from '../common/PolicyPage';

const TermsOfService: React.FC = () => {
  return <PolicyPage name="terms-of-service" title="Terms of Service" />;
};

export default TermsOfService;
